<template>
  <transition v-cloak name="modal">
    <v-modal
      data-test-remove-proposal-message-modal
      :is-open="open"
      data-test-proposal-basket-modal-remove-message
      @close="onClose"
    >
      <template #title>
        <h2 data-test-proposal-basket-modal-remove-message-headline v-html="headline" />
      </template>
      <template #content>
        <div data-test-proposal-basket-modal-remove-message-content v-html="content" />
      </template>
      <template #buttons>
        <div>
          <button
            data-test-proposal-basket-modal-remove-message-button
            class="button large"
            @click="onClose"
            v-html="buttonLabel"
          />
        </div>
      </template>
    </v-modal>
  </transition>
</template>
<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'RemoveProposalMessageModal',
  props: {
    open: {
      type: Boolean,
      default: () => false
    },
    headline: {
      type: String,
      default: () => ''
    },
    content: {
      type: String,
      default: () => ''
    },
    buttonLabel: {
      type: String,
      default: () => ''
    }
  },
  methods: {
    onClose(): void {
      this.$emit('close');
    }
  }
});
</script>
